"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domofon = void 0;
var bus_1 = require("./bus");
/**
 * Класс, осуществляющий приём и передачу сообщений между родительским окном и дочерним (<iframe>, window.open(), etc)
 */
var Domofon = /** @class */ (function () {
    function Domofon(props) {
        var _this = this;
        this.props = props;
        this.bus = new bus_1.Bus();
        this.onMessage = function (e) {
            var _a;
            var _b = _this.props, source = _b.source, onMessage = _b.onMessage, onError = _b.onError;
            if (!source.origins.includes(e.origin)) {
                return;
            }
            var packedMessage = e.data;
            // у сообщений от провайдера авторизации есть специальный признак, проверяем его
            if (!packedMessage.__authProviderMessage) {
                return;
            }
            try {
                var unpackedMessage = {
                    name: packedMessage.name,
                    source: e.source,
                    origin: e.origin,
                };
                if (packedMessage.payload) {
                    unpackedMessage.payload = JSON.parse(packedMessage.payload);
                }
                if (packedMessage._meta) {
                    unpackedMessage._meta = JSON.parse(packedMessage._meta);
                }
                onMessage(unpackedMessage);
                _this.bus.publish(unpackedMessage.name, unpackedMessage, (_a = unpackedMessage._meta) === null || _a === void 0 ? void 0 : _a.correlationId);
            }
            catch (error) {
                onError === null || onError === void 0 ? void 0 : onError(error);
            }
        };
        window.addEventListener('message', this.onMessage);
    }
    Domofon.prototype.destroy = function () {
        window.removeEventListener('message', this.onMessage);
    };
    Domofon.prototype.sendBroadcastMessage = function (message, correlationId) {
        var _a, _b, _c;
        // Рассылаем сообщения во все возможные места расположения iframe авторизации
        // (безопасно, тк сообщение получит только iframe подходящий по Origin)
        this.sendMultipleMessages(message, (_a = window.top) === null || _a === void 0 ? void 0 : _a.frames, correlationId);
        if (window.parent && window.parent !== window.top) {
            this.sendMultipleMessages(message, window.parent.frames, correlationId);
        }
        if (window.opener) {
            this.sendMultipleMessages(message, window.opener.frames, correlationId);
        }
        if ((_b = window.parent) === null || _b === void 0 ? void 0 : _b.opener) {
            this.sendMultipleMessages(message, (_c = window.parent) === null || _c === void 0 ? void 0 : _c.opener.frames, correlationId);
        }
    };
    Domofon.prototype.sendMultipleMessages = function (message, targetWindows, correlationId) {
        if (!targetWindows) {
            return;
        }
        for (var i = 0; i < targetWindows.length; i++) {
            this.sendMessage(message, correlationId, targetWindows[i]);
        }
    };
    Domofon.prototype.sendMessage = function (message, correlationId, targetWindow, targetOrigin) {
        var _a = this.props, target = _a.target, domofonId = _a.domofonId;
        var currentTargetWindow = targetWindow || (target === null || target === void 0 ? void 0 : target.window);
        var origin = targetOrigin || (target === null || target === void 0 ? void 0 : target.origin);
        if (!currentTargetWindow || !origin) {
            return;
        }
        var packedMessage = {
            name: message.name,
            // добавляем сообщениям специальный признак, чтобы можно было отличить сообщения
            // от/для провайдера авторизации от какого-нибудь шального вызова postMessage где-нибудь не в нашем коде
            __authProviderMessage: true,
            _meta: JSON.stringify({
                domofonId: domofonId,
                correlationId: correlationId,
            }),
        };
        if (message.payload) {
            packedMessage.payload = JSON.stringify(message.payload);
        }
        currentTargetWindow.postMessage(packedMessage, origin);
    };
    Domofon.prototype.request = function (message, responseMessageName, correlationId) {
        var _this = this;
        var _a;
        var requesting = new Promise(function (resolve) {
            _this.bus.subscribe(responseMessageName, function (message) {
                resolve(message);
            }, correlationId);
        });
        if (!((_a = this.props.target) === null || _a === void 0 ? void 0 : _a.window)) {
            this.sendBroadcastMessage(message, correlationId);
        }
        else {
            this.sendMessage(message, correlationId);
        }
        return requesting;
    };
    Domofon.prototype.unsubscribe = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.bus).unsubscribe.apply(_a, args);
    };
    Domofon.prototype.subscribe = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.bus).subscribe.apply(_a, args);
    };
    return Domofon;
}());
exports.Domofon = Domofon;
//# sourceMappingURL=domofon.js.map